module.exports = __webpack_public_path__ + "static/floralbathmain-3e0f0c82312ac85ca353f1b286b53db9.png";